import { ButtonBase, Text } from '@belong/ui';
import cx from 'clsx';
import { CoverageRegionModel } from 'src/api/models';
import styles from './region-card.module.css';
import { REGION_SELECT_STRINGS } from './strings';

type RegionCardProps = {
  name?: string;
  status?: CoverageRegionModel['status'];
  onClick: () => void;
};

export function RegionCard({ name, status, onClick }: RegionCardProps) {
  return (
    <ButtonBase
      onClick={onClick}
      onTouchEnd={onClick}
      type="button"
      className="w-full sm:w-auto"
    >
      <div
        className={cx(
          styles.container,
          'flex flex-col justify-center rounded shadow relative px-2xs',
          'border-3 border-solid border-white hover:border-navy transition duration-hover',
        )}
      >
        <Text variant="p1" fontWeight="semibold" className="truncate">
          {name}
        </Text>
        {status === 'ComingSoon' && (
          <Text variant="p1" className="leading-p2">
            {REGION_SELECT_STRINGS['card.comingSoon']}
          </Text>
        )}
      </div>
    </ButtonBase>
  );
}
